module.exports = __webpack_public_path__ + "media/images/icons/outlined/loading-3bd3e02c53619a4ae5b93100baa1f105.svg";